module.exports = __webpack_public_path__ + "img/european-dragon.24ac713b.png";